import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import Button from 'reactstrap/lib/Button';
import { IncentivesElectricEntities } from 'client/data/models/incentives-electric';
import { modalMousedownTrackingFix } from 'site-modules/shared/utils/modal-tracking-fix';

import './incentives-modal.scss';

export function IncentivesModal({ modalData = null, toggleModal, children = null }) {
  return (
    <Modal
      size="lg"
      className="incentives-modal my-0 mt-3_5"
      contentClassName="bg-cool-gray-90 p-1"
      isOpen={!!modalData}
      toggle={toggleModal}
      aria-label="Incentive Details"
    >
      <ModalBody data-testid="modal-body" onMouseDown={modalMousedownTrackingFix}>
        <Button
          className="size-20 border-0 p-0 pos-a top-0 right-0 mt-1 me-1"
          outline
          color="info"
          onClick={toggleModal}
        >
          <span className="visually-hidden">Close modal</span>
          <i className="icon-cross2" aria-hidden />
        </Button>
        {children}
      </ModalBody>
    </Modal>
  );
}

IncentivesModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  modalData: PropTypes.oneOfType([
    IncentivesElectricEntities.IncentivesByModelYearData,
    IncentivesElectricEntities.IncentiveData,
  ]),
  children: PropTypes.node,
};
